// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1y6m{justify-content:flex-start}\n._1bahesu3{justify-content:flex-end}\n._1e0c116y{display:inline-flex}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._syaz1ick{color:var(--ds-text-danger,#de350b)}\n._syaz1l5o{color:var(--ds-text-danger,#ff5630)}\n._u5f319bv{padding-right:10px}\n._u5f31b66{padding-right:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
